import React from "react";
import { Blockquote, Ul, Ol } from "./elements";
import { Link } from "react-router-dom";

export const books = {
    neurotribes: {
        title: "NeuroTribes",
        author: "Steve Silberman",
        topic: "Social Science",
        body: (
            <div>
                {/*<Blockquote>
                    [Leo] Kanner named their condition autism -- from the Greek
                    word for self, autos -- because they seemed happiest in
                    isolation.
                </Blockquote>*/}
                <Blockquote>
                    Neurodiversity: the notion that conditions like autism,
                    dyslexia, and attention-deficit/hyperactivity disorder
                    (ADHD) should be regarded as naturally occurring cognitive
                    variations with distinctive strengths that have contributed
                    to the evolution of technology and culture rather than mere
                    checklists of deficits and dysfunctions. Though the spectrum
                    model of autism and the concept of neurodiversity are widely
                    believed to be products of our postmodern world, they turn
                    out to be very old ideas, proposed by Hans Asperger in his
                    first public lecture on autism in 1938. The idea of
                    neurodiversity has inspired the creation of a rapidly
                    growing civil rights movement based on the simple idea that
                    the most astute interpreters of autistic behavior are
                    autistic people themselves.
                </Blockquote>
            </div>
        ),
    },
    // "if-this-isnt-nice-what-is": {
    //     title: "If This Isn't Nice, What Is?",
    //     author: "Kurt Vonnegut",
    //     topic: "History",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 Let's divide up the wealth more fairly than we have divided
    //                 it up so far. Let's make sure that everybody has enough to
    //                 eat, and a decent place to live, and medical help when he
    //                 needs it. Let's stop spending money on weapons, which don't
    //                 work anyway, thank God, and spend money on each other.
    //             </Blockquote>
    //             {/*<Blockquote>
    //                 Bertrand Russell declared that, in case he met God, he would
    //                 say to Him, "Sir, you did not give us enough information." I
    //                 would add to that, "All the same, Sir, I'm not persuaded
    //                 that we did the best we could with the information we had.
    //                 Toward the end there, anyway we had tons of information."
    //                 Our most dismaying failure is in the use of our knowledge of
    //                 what human beings need in the way of bodily and spiritual
    //                 nourishment.
    //             </Blockquote>*/}
    //         </div>
    //     ),
    // },
    "you-are-here": {
        title: "You Are Here",
        author: "Thich Nhat Hanh",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    The Buddha said, "Life is accessible only in the present
                    moment." Life in all its wonders is accessible right now. So
                    we train in coming back to the present moment.
                </Blockquote>
                <Blockquote>
                    The way to maintain your presence in the here and now is
                    through mindfulness of the breath. ... As you breathe in,
                    you can say to yourself, "Breathing in, I know that I am
                    breathing in." When you do this the energy of mindfulness
                    embraces your in-breath, just like sunlight touching the
                    leaves and branches of a tree. ... As you breathe out, you
                    can gently say, "Breathing out, I know that I am breathing
                    out." Buddhist practice is based on nonviolence and
                    nondualism. You don't have to struggle with your breath.
                </Blockquote>
                <Blockquote>
                    You could also say, "in-breath, out-breath." Or even just:
                    "in, out." It's very simple, yet you can regard this
                    practice as recognition of everything that is happening in
                    the present moment. ... During this time, all thoughts stop.
                    The past, the future, your memories and plans -- you drop
                    everything. You are your in-breath.
                </Blockquote>
                <p>
                    Also see:{" "}
                    <Link
                        to={
                            "https://plumvillage.org/mindfulness/the-5-mindfulness-trainings"
                        }
                    >
                        The Five Mindfulness Trainings
                    </Link>
                    .
                </p>
                {/*<Blockquote>
                    If something negative comes to the surface, such as your
                    despair or anger ... you need the energy of mindfulness to
                    embrace it. Breathing in, I know that anger is there in me.
                    Breathing out, I care for my anger. ... embrace the pain
                    that is coming to the surface. ... You can do mindful
                    walking or sitting meditation at the same time that you are
                    embracing your pain, because this energy of mindfulness will
                    help you hold your pain.
                </Blockquote>
                <Blockquote>
                    We must bring about a revolution in our thinking: we must
                    stop. ... The wave is already water. Does the wave have to
                    go looking for water? No. It is the same for you. You have
                    God within you, so you do not have to look for God. ...
                    Water is accessible to the wave twenty-four hours a day.
                    Peace, solidity, and the light of God inhabit you and are
                    accessible at any time. And yet you keep running. Year after
                    year, lifetime after lifetime, you keep looking. You must
                    come back to yourself to touch the ground of your being, the
                    ultimate dimension of reality, nirvana.
                </Blockquote>*/}
            </div>
        ),
    },
    "name-of-this-band-is-rem": {
        title: "The Name of This Band Is R.E.M.",
        author: "Peter Ames Carlin",
        topic: "History",
        blank: true,
        body: (
            <div>
                <Blockquote></Blockquote>
            </div>
        ),
    },
    // "pragmatism-and-other-writings": {
    //     title: "Pragmatism and Other Writings",
    //     author: "William James",
    //     topic: "Philosophy",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote></Blockquote>
    //         </div>
    //     ),
    // },
    "art-of-living": {
        title: "The Art of Living",
        author: "Epictetus and Sharon Lebell",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    Understand what freedom is and how it is achieved. Freedom
                    isn't the right or ability to do whatever you please.
                    Freedom comes from understanding the limits of our own power
                    and the natural limits set in place by divine providence. By
                    accepting life's limits and inevitabilities and working with
                    them rather than fighting them, we become free.
                </Blockquote>
                <Blockquote>
                    As you think, so you become. Avoid superstitiously investing
                    events with power or meanings they don't have. Keep your
                    head. Our busy minds are forever jumping to conclusions,
                    manufacturing and interpreting signs that aren't there.
                    Assume, instead, that everything that happens to you does so
                    for some good. That if you decided to be lucky, you are
                    lucky. All events contain an advantage for you -- if you
                    look for it!
                </Blockquote>
                <Blockquote>
                    When you know you've done the best you can under the
                    circumstances, you can have a light heart. Your mind doesn't
                    have to moonlight, making excuses, thinking up alibis,
                    defending your honor, feeling guilty or remorseful. You can
                    simply, cleanly, move on to the next thing.
                </Blockquote>
            </div>
        ),
    },
    range: {
        title: "Range",
        author: "David Epstein",
        topic: "Social Science",
        body: (
            <div>
                <Blockquote>
                    [Django Reinhardt] was eighteen [in 1928] when a candle in
                    his wagon ignited a batch of celuloid flowers that his wife,
                    Bella, had fashioned for a funeral. The wagon exploded into
                    an inferno. Django was burned over half his body and ended
                    up bedridden for a year and a half. For the rest of his life
                    the pinkie and ring finger of his left hand, his fret hand,
                    were dangling flesh, useless on the strings. Django was used
                    to improvising. ... He taught himself how to play chords
                    with a thumb and two fingers. His left hand had to sprint up
                    and down the neck of his guitar, the index and middle finger
                    flitting waterbug-like over the strings. He emerged with a
                    new way of handling the instrument, and his creativity
                    erupted. With a French violinist, Django fused dancehall
                    musette with jazz and invented a new form of improvisational
                    music that defied easy characterization, so it was just
                    called "Gypsy jazz." ... The author of{" "}
                    <i>The Making of Jazz</i> anointed the man who could neither
                    read music nor study it with traditional fingerings "without
                    question, the single most important guitarist in the history
                    of jazz."
                </Blockquote>
                {/*<Blockquote>
                    [Athletes and musicians] are practically synonymous with
                    early specialization. But among athletes who go on to become
                    elite, broad early experience and delayed specialization is
                    the norm. Musicians arrive at greatness via an incredible
                    diversity of paths, but early hyperspecialization is often
                    not necessary for skill development and in the more
                    improvisational forms it is rare.
                </Blockquote>
                <Blockquote>
                    Todd Rose, director of Harvard's Mind, Brain, and Education
                    program, and computational neuroscientist Ogi Ogas cast a
                    broad net when they set out to study unusually winding
                    career paths. They wanted to find people who are fulfilled
                    and successful, and who arrived there circuitously. They
                    recruited high fliers from master sommeliers and personal
                    organizers to animal trainers, piano tuners, midwives,
                    architects, and engineers. "We guessed we'd have to
                    interview five people for each one who created their own
                    path," Ogas told me. "We didn't think it would be a
                    majority, or even a lot." It turned out virtually every
                    person had followed what seemed like an unusual path. "What
                    was even more incredible is that they all thought they were
                    the anomaly," Ogas said. Forty-five of the first fifty
                    subjects detailed professional paths so sinuous that they
                    expressed embarrassment over jumping from thing to thing
                    over their careers.
                </Blockquote>*/}
            </div>
        ),
    },
    // "prompt-engineering-for-generative-ai": {
    //     title: "Prompt Engineering for Generative AI",
    //     author: "James Phoenix and Mike Taylor",
    //     topic: "Technical",
    //     body: (
    //         <div>
    //             <p>The Five Principles of Prompting are:</p>
    //             <Blockquote>
    //                 Give Direction: Describe the desired style in detail, or
    //                 reference a relevant persona.
    //             </Blockquote>
    //             <Blockquote>
    //                 Specify Format: Define what rules to follow, and the
    //                 required structure of the response.
    //             </Blockquote>
    //             <Blockquote>
    //                 Provide Examples: Insert a diverse set of test cases where
    //                 the task was done correctly.
    //             </Blockquote>
    //             <Blockquote>
    //                 Evaluate Quality: Identify errors and rate responses,
    //                 testing what drives performance.
    //             </Blockquote>
    //             <Blockquote>
    //                 Divide Labor: Split tasks into multiple steps, chained
    //                 together for complex goals.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "meditations-waterfield": {
    //     title: "Meditations",
    //     author: "Marcus Aurelius and Robin Waterfield",
    //     topic: "Philosophy",
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 The command center doesn't disturb itself, by which I mean
    //                 that it doesn't alarm itself, distress itself, or give in to
    //                 desire. If anyone else is able to alarm or distress it,
    //                 that's up to him; the command center will not of its own
    //                 accord cause any such worsening of itself. It's up to the
    //                 body to ensure that it doesn't suffer, if it can, and it's
    //                 up to the soul -- the part that feels fear and distress --
    //                 to speak out if it has such experiences. But the faculty
    //                 that forms beliefs about these things won't be affected at
    //                 all, because it won't make that kind of judgment as a
    //                 concession to the soul. In itself, the command center has no
    //                 needs unless it creates one for itself, and it is therefore
    //                 unperturbed and unhindered, unless it disturbs and hinders
    //                 itself.
    //             </Blockquote>
    //             <Blockquote>
    //                 Wherever you find yourself, it's within your power, at every
    //                 moment, to be reverently content with your present
    //                 circumstances, to behave with justice toward the people who
    //                 are presently around you, and to manage your present
    //                 impressions.
    //             </Blockquote>
    //             <Blockquote>
    //                 Never stop checking out the people whose endorsement you
    //                 want -- that is, their command centers. If you look into
    //                 where their beliefs and impulses are coming from, not only
    //                 will you not criticize them when they make involuntary
    //                 mistakes but you won't require their endorsement either.
    //             </Blockquote>
    //             <Blockquote>
    //                 Get through to everyone's command center, and make it
    //                 possible for everyone to get through to yours.
    //             </Blockquote>
    //             <Blockquote>
    //                 God sees all command centers stripped of their material
    //                 vessels, their worthless casings, because he has only his
    //                 intelligence with which to make contact, and the only
    //                 contact he has is with what has flowed and been channeled
    //                 from him to them.
    //             </Blockquote>
    //             <Blockquote>
    //                 Remember that "Everything is as you take it to be" -- and
    //                 that what you take things to be is up to you.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    meditations: {
        title: "Meditations",
        author: "Marcus Aurelius and Gregory Hays",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    Not to feel exasperated, or defeated, or despondent because
                    your days aren't packed with wise and moral actions. But to
                    get back up when you fail, to celebrate behaving like a
                    human -- however imperfectly -- and fully embrace the
                    pursuit you've embarked on.
                </Blockquote>
                <Blockquote>
                    So remember this principle when something threatens to cause
                    you pain: the thing itself was no misfortune at all; to
                    endure it and prevail is great good fortune.
                </Blockquote>
                <Blockquote>
                    Let it happen, if it wants, to whatever it can happen to.
                    And what's affected can complain about it if it wants. It
                    doesn't hurt me unless I interpret its happening as harmful
                    to me. I can choose not to.
                </Blockquote>
                {/*<Blockquote>
                    In the ring, our opponents can gouge us with their nails or
                    butt us with their heads and leave a bruise, but we don't
                    denounce them for it or get upset with them or regard them
                    from then on as violent types. We just keep an eye on them after
                    that. Not out of hatred or suspicion. Just keeping a
                    friendly distance. We need to do that in other areas. We
                    need to excuse what our sparring partners do, and just keep
                    our distance -- without suspicion or hatred.
                </Blockquote>
                <Blockquote>
                    You take things you don't control and define them as "good"
                    or "bad." And so of course when the "bad" things happen, or
                    the "good" ones don't, you blame the gods and feel hatred
                    for the people responsible -- or those you decide to make
                    responsible. Much of our bad behavior stems from trying to
                    apply those criteria. If we limited "good" and "bad" to our
                    own actions, we'd have no call to challenge God, or to treat
                    other people as enemies.
                </Blockquote>
                <Blockquote>
                    To welcome with affection what is sent by fate.
                </Blockquote>*/}
                <Blockquote>
                    Forget the future. When and if it comes, you'll have the
                    same resources to draw on -- the same logos.
                </Blockquote>
                {/*<Blockquote>
                    Don't let your imagination be crushed by life as a whole.
                    Don't try to picture everything bad that could possibly
                    happen. Stick with the situation at hand.
                </Blockquote>*/}
                <Blockquote>
                    If you'd only let go of the past, entrust the future to
                    Providence, and guide the present toward reverence and
                    justice. Reverence: so you'll accept what you're allotted.
                    Nature intended it for you, and you for it. Justice: so that
                    you'll speak the truth, frankly and without evasions, and
                    act as you should -- and as other people deserve.
                </Blockquote>
                <Blockquote>
                    Nothing but first impressions. That someone has insulted
                    you, for instance. That -- but not that it's done you any
                    harm. The fact that my son is sick -- that I can see. But
                    "that he might die of it," no. Stick with first impressions.
                    Don't extrapolate.
                </Blockquote>
                {/*<Blockquote>
                    Everything's destiny is to change, to be transformed, to
                    perish. So that new things can be born.
                </Blockquote>
                <Blockquote>
                    Remember, you shouldn't be surprised that a fig tree
                    produces figs, nor the world what it produces. A good doctor
                    isn't surprised when his patients have fevers, or a helmsman
                    when the wind blows against him.
                </Blockquote>
                <Blockquote>
                    Today I escaped anxiety. Or no, I discarded it, because it
                    was within me, in my own perceptions -- not outside.
                </Blockquote>
                <Blockquote>
                    Choose not to be harmed -- and you won't feel harmed. Don't
                    feel harmed -- and you haven't been.
                </Blockquote>
                <Blockquote>
                    Objective judgment, now, at this very moment. Unselfish
                    action, now, at this very moment. Willing acceptance -- now,
                    at this very moment -- of all external events. That's all you
                    need.
                </Blockquote>*/}
                <Blockquote>
                    Don't be overheard complaining... Not even to yourself.
                </Blockquote>
                {/*<p>From the introduction by Gregory Hays:</p>
                <Blockquote>
                    I suspect that if asked what it was he studied, his answer
                    would have been not "Stoicism" but simply "philosophy." ...
                    While built on a Stoic foundation, [Meditations] also refers
                    to and quotes a wide range of figures, both precursors of
                    the Stoics and representatives of rival schools.
                </Blockquote>
                <Blockquote>
                    You don't have to turn this into something. It doesn't have
                    to upset you.
                </Blockquote>
                <Blockquote>
                    The only thing that isn't worthless: to live this life out
                    truthfully and rightly. And be patient with those who don't.
                </Blockquote>*/}
                <Blockquote>
                    Things have no hold on the soul. They stand unmoving,
                    outside it. Disturbance comes only from within -- from our
                    own perceptions.
                </Blockquote>
                <Blockquote>
                    The gods are not to blame. They do nothing wrong, on purpose
                    or by accident. Nor men either; they don't do it on purpose.
                    No one is to blame.
                </Blockquote>
            </div>
        ),
    },
    // "calendar-of-wisdom": {
    //     title: "A Calendar of Wisdom",
    //     author: "Leo Tolstoy",
    //     topic: "Philosophy",
    //     body: (
    //         <div>
    //             {/*<Blockquote>
    //                 Christ revealed to humanity those things which their best
    //                 selves already knew; that people are equal because the same
    //                 spirit lives in all of them. ... Learn from the small
    //                 children, behave like children, and treat all people on an
    //                 equal basis, with love and tenderness.
    //             </Blockquote>
    //             <Blockquote>
    //                 War and Christianity are not compatible. War is one of the
    //                 worst, most terrible things in this world.{" "}
    //                 <i>
    //                     War in this world can be stopped not by the ruling
    //                     establishment, but by those who suffer from the war.
    //                     They will do the most natural thing: stop obeying
    //                     orders.
    //                 </i>{" "}
    //                 The armed world and the wars it wages will be destroyed one
    //                 day, but not by the kings or the rulers of this world. War
    //                 is profitable for them. War will stop the moment the people
    //                 who suffer from war fully understand that it is evil.
    //             </Blockquote>*/}
    //             <Blockquote>
    //                 In all cases, when people use violence, you should try to
    //                 convince them not to. You should try to apply wise,
    //                 convincing arguments, appealing not to the everyday world,
    //                 but to their higher spiritual understanding.
    //             </Blockquote>
    //             <Blockquote>
    //                 There is only one thing in this world which is worth
    //                 dedicating all your life. This is creating more love among
    //                 people and destroying barriers which exist between them.
    //             </Blockquote>
    //             <Blockquote>
    //                 The reasons which governments give for wars are always
    //                 screens, behind which lie completely different reasons and
    //                 motives.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    "stoicism-western-buddhism": {
        title: "Stoicism and Western Buddhism",
        author: "Patrick Ussher",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    Strange as it may seem, the Buddhism that most Westerners
                    practice today is not the same as the Buddhism of the Buddha
                    and, likewise, the Stoicism of many modern-day Stoics is not
                    the same philosophy as that of the original Stoa. And yet
                    the subsequent modern 'reinventions' of both philosophies
                    are far more similar to each other than their respective
                    ancient forms ever were.
                </Blockquote>
                <Blockquote>
                    The ability to learn to observe thoughts and feelings from a
                    slight distance, as one does in Buddhist meditation, would
                    be very helpful for applying Stoic ethics in the moment more
                    skillfully.
                </Blockquote>
                <Blockquote>
                    One way to link these philosophies together would be to add
                    compassion, love and acceptance to the traditional Stoic
                    virtues. In other words, one could add those more loving and
                    maternal qualities to the Stoic ethical system such that,
                    when a Stoic asks herself, 'what is "up to me" in this
                    current situation?', compassion, love and acceptance would
                    be as valid answers as fortitude, courage, moderation,
                    justice, and other Stoic ethical qualities.
                </Blockquote>
            </div>
        ),
    },
    "complete-works": {
        title: "The Complete Works",
        author: "Epictetus and Robin Waterfield",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    Material things are indifferent, but the use one makes of
                    them isn't. How, then, is one to retain one's
                    self-possession and peace of mind, and at the same time be
                    careful rather than purposeless or negligent? If one
                    imitates people playing a board game. The counters are
                    indifferent and the dice are indifferent: how do I know
                    which way they'll fall? But to use the throw carefully and
                    skillfully, that's my job.
                </Blockquote>
                <Blockquote>
                    So what should a philosopher say in the face of any harsh
                    experience? 'This is what I've been training for. This is
                    what I've been practicing for.'
                </Blockquote>
                <Blockquote>
                    People are troubled not by things but by their judgments
                    about things.
                </Blockquote>
                <Blockquote>
                    Blaming others when things are going badly for him is what
                    an uneducated person does. Blaming himself is what a
                    partially educated person does. Blaming neither others nor
                    himself is what a fully educated person does.
                </Blockquote>
                <Blockquote>
                    Instead of wishing that things would happen as you'd like,
                    wish that they would happen as they do, and then you'll be
                    content.
                </Blockquote>
                <Blockquote>
                    Everything has two handles, one of which makes it bearable,
                    the other unbearable. If your brother's treating you badly,
                    don't take hold of the fact that he's mistreating you,
                    because that's the handle that makes it unbearable, but take
                    hold of the fact that he's your brother, that you grew up
                    together. Then you'll be holding the situation by that which
                    makes it bearable.
                </Blockquote>
            </div>
        ),
    },
    "discourses-and-selected-writings": {
        title: "Discourses and Selected Writings",
        author: "Epictetus and Robert Dobbin",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    In life our first job is this, to divide and distinguish
                    things into two categories: externals I cannot control, but
                    the choices I make with regard to them I do control. Where
                    will I find good and bad? In me, in my choices. Don't ever
                    speak of 'good' or 'bad', 'advantage' or 'harm', and so on,
                    of anything that is not your responsibility.
                </Blockquote>
                <Blockquote>
                    Model yourself on card players. The chips don't matter, and
                    the cards don't matter; how can I know what the deal will
                    be? But making careful and skilful use of the deal -- that's
                    where my responsibility begins.
                </Blockquote>
                <Blockquote>
                    It's the only thing in our power. Wealth is not, nor is
                    health or fame -- nothing, in a word, is within our power
                    except using impressions correctly.
                </Blockquote>
                <Blockquote>
                    We are responsible for some things, while there are others
                    for which we cannot be held responsible. The former include
                    our judgment, our impulse, our desire, aversion, and our
                    mental faculties in general; the latter include the body,
                    material possessions, our reputation, status, and in a word,
                    anything not in our power to control.
                </Blockquote>
                <Blockquote>
                    So make a practice at once of saying to every strong
                    impression: "An impression is all you are, not the source of
                    the impression." Then test and assess it with your criteria,
                    but one primarily: ask, "Is this something that is, or is
                    not, in my control?" And if it's not one of the things that
                    you control, be ready with the reaction, "Then it's none of
                    my concern."
                </Blockquote>
                <Blockquote>
                    If you are ever tempted to look for outside approval,
                    realize that you have compromised your integrity.
                </Blockquote>
                {/*<Blockquote>
                    It is essential that we not respond impulsively to
                    impressions; take a moment before reacting, and you will
                    find it easier to maintain control.
                </Blockquote>*/}
                <Blockquote>
                    Don't hope that events will turn out the way you want,
                    welcome events in whichever way they happen: this is the
                    path to peace.
                </Blockquote>
            </div>
        ),
    },
    letters: {
        title: "Letters",
        author: "Kurt Vonnegut",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    The country I used to write for is no longer anywhere to be
                    found, hard as I may look for it. What made it disappear is
                    TV, which turns out to be life enough for almost everybody.
                </Blockquote>
                <Blockquote>
                    And how should we behave during an apocalypse? We should be
                    unusually kind to one another, certainly. But we should also
                    stop being so serious. Jokes help a lot. And get a dog if
                    you don't already have one.
                </Blockquote>
            </div>
        ),
    },
    "man-without-a-country": {
        title: "A Man Without a Country",
        author: "Kurt Vonnegut",
        topic: "History",
        body: (
            <div>
                {/*<Blockquote>
                    "Socialism" is no more an evil word than "Christianity."
                    Socialism no more prescribed Joseph Stalin and his secret
                    police and shuttered churches than Christianity prescribed
                    the Spanish Inquisition. Christianity and socialism alike,
                    in fact, prescribe a society dedicated to the proposition
                    that all men, women, and children are created equal and
                    shall not starve.
                </Blockquote>*/}
                <Blockquote>
                    The arts are not a way to make a living. They are a very
                    human way of making life more bearable. Practicing an art,
                    no matter how well or badly, is a way to make your soul
                    grow, for heaven's sake. Sing in the shower. Dance to the
                    radio. Tell stories. Write a poem to a friend, even a lousy
                    poem. Do it as well as you possibly can. You will get an
                    enormous reward. You will have created something.
                </Blockquote>
                <Blockquote>
                    Our children have inherited technologies whose byproducts,
                    whether in war or peace, are rapidly destroying the whole
                    planet as a breathable, drinkable system for supporting life
                    of any kind.
                </Blockquote>
                <Blockquote>
                    The biggest truth to face now -- what is probably making me
                    unfunny now for the remainder of my life -- is that I don't
                    think people give a damn whether the planet goes on or not.
                    It seems to me as if everyone is living as members of
                    Alcoholics Anonymous do, day by day. And a few more days
                    will be enough. I know of very few people who are dreaming
                    of a world for their grandchildren.
                </Blockquote>
                <Blockquote>
                    How do humanists feel about Jesus? I say of Jesus, as all
                    humanists do, "If what he said is good, and so much of it is
                    absolutely beautiful, what does it matter if he was God or
                    not?"
                </Blockquote>
                <Blockquote>
                    Welcome to Earth, young man. It's hot in the summer and cold
                    in the winter. It's round and wet and crowded. At the
                    outside, Joe, you've got about a hundred years here. There's
                    only one rule that I know of: Goddamn it, Joe, you've got to
                    be kind!
                </Blockquote>
            </div>
        ),
    },
    "tipping-point": {
        title: "The Tipping Point",
        author: "Malcolm Gladwell",
        topic: "Social Science",
        blank: true,
    },
    // "hiking-with-nietzsche": {
    //     title: "Hiking with Nietzsche",
    //     author: "John Kaag",
    //     topic: "Philosophy",
    //     body: (
    //         <div>
    //             <p>
    //                 Friedrich Nietzsche was influenced by the writings of Ralph
    //                 Waldo Emerson.
    //             </p>
    //             <Blockquote>
    //                 Nietzsche was drawn to Emerson's Promethean individualism,
    //                 his suggestion that loneliness was not something to be
    //                 remedied at all costs but rather a moment of independence to
    //                 be contemplated and even enjoyed. In fact, isolation, to the
    //                 extent that it allows one to be free from societal
    //                 constraint, is the most appropriate condition for a
    //                 philosopher.
    //             </Blockquote>
    //             <Blockquote>
    //                 Emerson's essay "Compensation," the sister essay to his more
    //                 famous "Self-Reliance," promised that "every evil to which
    //                 we do not succumb is a benefactor." Nietzsche spent most of
    //                 his life trying to internalize this message, echoing it
    //                 repeatedly, most famously in{" "}
    //                 <i>The Twilight of the Idols</i>: "What does not kill me,"
    //                 he asserted, "makes me stronger."
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // blink: {
    //     title: "Blink",
    //     author: "Malcolm Gladwell",
    //     topic: "Social Science",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 When making a decision of minor importance, I have always
    //                 found it advantageous to consider all the pros and cons. In
    //                 vital matters, however, such as the choice of a mate or a
    //                 profession, the decision should come from the unconscious,
    //                 from somewhere within ourselves. In the important decisions
    //                 of personal life, we should be governed, I think, by the
    //                 deep inner needs of our nature. -- Sigmund Freud
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    "carry-on": {
        title: "Carry On",
        author: "John Lewis",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    You can write your own script and determine how you live
                    each moment. And how you will respond to the people and
                    events throughout your day. You don't have to jump ahead and
                    think always about the future. Take in and absorb every
                    moment, and you'll find yourself noticing the little things
                    -- whether it's the birds chirping, the dew on the grass,
                    the sweetness of morning, or the wind blowing on your face
                    and skin.
                </Blockquote>
                <Blockquote>
                    I believe that most people are kind and decent. They have
                    good character and can tell the difference between right and
                    wrong, and they have the will to choose. This is what Dr.
                    King understood when he shared his dream that the day would
                    come when we wouldn't be judged "by the color of our skin
                    but the content of our character." We all have free will. We
                    can choose to be a force for truth and light. We can choose
                    to have and to keep the strong character we were born with,
                    to have strong mental and moral qualities. The choice is
                    ours.
                </Blockquote>
                <Blockquote>
                    Marriage is one of the most important decisions that you
                    will make. You have to choose wisely because this is the
                    person who will be with you in those quiet moments when
                    there is nobody else. Find someone with whom you're
                    compatible and with whom you're a friend. Someone who
                    listens to you and cares about you for who you are. Someone
                    you can grow with and has your best interests at heart --
                    and someone who has your back.{" "}
                    {/*At the same time, give a little
                    space and don't suffocate your partner.*/}
                </Blockquote>
            </div>
        ),
    },
    "atomic-habits": {
        title: "Atomic Habits",
        author: "James Clear",
        topic: "Social Science",
        body: (
            <div>
                <Blockquote>
                    The problem with goals-first mentality is that you're
                    continually putting happiness off until the next milestone.
                    ... A systems-first mentality provides the antidote. When
                    you fall in love with the process rather than the product,
                    you don't have to wait to give yourself permission to be
                    happy. You can be satisfied anytime your system is running.
                    And a system can be successful in many different forms, not
                    just the one you first envision.
                </Blockquote>
                <Blockquote>
                    Progress requires unlearning. Becoming the best version of
                    yourself requires you to continuously edit your beliefs, and
                    to upgrade and expand your identity.
                </Blockquote>
                <Blockquote>
                    The focus should always be on becoming that type of person,
                    not getting a particular outcome.
                </Blockquote>
                <Blockquote>
                    Anyone can have a bad performance, a bad workout, or a bad
                    day at work. But when successful people fail, they rebound
                    quickly. The breaking of a habit doesn't matter if the
                    reclaiming of it is fast.
                </Blockquote>
                <Blockquote>
                    The only way to become excellent is to be endlessly
                    fascinated by doing the same thing over and over. You have
                    to fall in love with boredom.
                </Blockquote>
                {/*<Blockquote>
                    If you keep showing up, you'll almost certainly break
                    through — but probably not in the way you expected or
                    intended. You need enough persistence to keep working and
                    enough flexibility to enjoy success when it comes in a
                    different form than you imagined. (From the 3-2-1
                    newsletter)
                </Blockquote>
                <Blockquote>
                    People can sometimes be held hostage by their expectations.
                    They have a dream of something they would like to achieve or
                    a path they intend to follow, but their mindset falls apart
                    when things don't work out how they had hoped. The key is to
                    reach for an extremely high bar, but to be adaptable enough
                    to reframe the failures, disappointments, and defeats into
                    fuel for the next thing. Give your best effort, but no
                    matter how it works out, trust that life will be good for
                    you. Focus on how the world is working with you, not against
                    you. Everything you are given is material for the next move.
                    Everything. (From the 3-2-1 newsletter)
                </Blockquote>*/}
            </div>
        ),
    },
    "always-looking-up": {
        title: "Always Looking Up",
        author: "Michael J. Fox",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    I do consider myself a spiritual person. Too blessed to be
                    strictly agnostic, I have come to adhere to an ethical code
                    informed by the basic tenets of the major monotheistic
                    disciplines: "Do unto others as you would have them do unto
                    you," "Judge not lest ye yourself be judged," and at least a
                    half dozen of the Commandments.
                </Blockquote>
            </div>
        ),
    },
    "no-time-like-the-future": {
        title: "No Time Like the Future",
        author: "Michael J. Fox",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    I'm beginning to see that faith, or fear's opposite, can be
                    expressed as gratitude, which has always been the bedrock of
                    optimism.
                </Blockquote>
                <Blockquote>
                    With gratitude, optimism becomes sustainable.
                </Blockquote>
                <Blockquote>
                    Parents with multiple children are often asked if they have
                    a favorite. I always say, "Yeah, whichever one I'm with."
                </Blockquote>
            </div>
        ),
    },
    "neurodiversity-singer": {
        title: "Neurodiversity",
        author: "Judy Singer",
        topic: "Social Science",
        blank: true,
        body: (
            <div>
                {/*<Blockquote>
                    The concept arose as part of the 19th century drive to
                    classify, control and regulate the body, the means by which
                    the “classifiers” gained power at the expense of the
                    "classified" - those people who were unable keep up with
                    demand of the industrial revolution for speedy, efficient
                    and conformist workers. I learned how the notion of
                    disability served to distinguish between the "worthy" and
                    the "unworthy" poor, and how the distinction continues to
                    function as a means of social control and punishment in our
                    current welfare systems.
                </Blockquote>
                <Blockquote>
                    While my focus was on AS, I considered that the scope of
                    neurodiversity was far broader. It could encompass the
                    near-absurdist splinterings of the then DSM IV, even perhaps
                    gender identity and sexual preference, surely properties of
                    the mind.
                </Blockquote>
                <Blockquote>
                    I was dreaming of a grand new social movement for
                    neurological marginalised groups in the mould of the
                    feminist, gay liberation or disability movements.
                </Blockquote>*/}
            </div>
        ),
    },
    // "neurodiversity-armstrong": {
    //     title: "Neurodiversity",
    //     author: "Thomas Armstrong",
    //     topic: "Social Science",
    //     blank: true,
    //     body: (
    //         <div>
    //             {/*<Blockquote>
    //                 We need to reject the "disease-based" thinking that too
    //                 often dogs the lives of labeled individuals and embrace a
    //                 more positive vision of who they are, and who they can
    //                 become. The word "neurodiversity" conveys this sense of
    //                 affirmation. Just as we use the terms "cultural diversity"
    //                 and "biodiversity" to refer to the rich variety of social
    //                 heritage or biological life, we need a term that conveys a
    //                 sense of the richness of different kinds of brains.
    //             </Blockquote>*/}
    //         </div>
    //     ),
    // },
    innovators: {
        title: "The Innovators",
        author: "Walter Isaacson",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    [Grace Hopper's] crew helped popularize the terms bug and
                    debugging. The Mark II version of the Harvard computer
                    [which arrived in 1947] was in a building without window
                    screens. One night the machine conked out, and the crew
                    began looking for the problem. They found a moth with a
                    wingspan of four inches that had gotten smashed in one of
                    the electromechanical relays. It was retrieved and pasted
                    into the log book with Scotch tape. "Panel F (moth) in
                    relay," the entry noted. "First actual case of a bug being
                    found." From then on, they referred to ferreting out
                    glitches as "debugging the machine."
                </Blockquote>
            </div>
        ),
    },
    "revolutionary-genius-of-plants": {
        title: "The Revolutionary Genius of Plants",
        author: "Stefano Mancuso",
        topic: "Science",
        body: (
            <div>
                <Blockquote>
                    In the coming years, we will surely learn to harness the
                    power of groups better and better. We are at the very
                    beginning of a revolution that has much to teach us about
                    the true nature of intelligence and that will involve
                    increasingly large numbers of individuals in solving
                    problems and achieving goals that today are impossible. The
                    Internet is today's exemplar of the enormous power of
                    nonhierarchical and diffused organizations that, like plant
                    structures, is multiplying, gaining consensus, and above
                    all, producing excellent results. ... In 2050 there will be
                    ten billion people on earth, three and a half billion more
                    than we are today. Many are alarmed by this enormous
                    population growth, because they feel that we will not have
                    enough resources to supply everyone. I do not belong to
                    those ranks. Three and a half billion more thinking heads is
                    not a problem but a huge resource. Three and a half billion
                    people will be able to solve any problem -- as long as they
                    are free to think and innovate.
                </Blockquote>
            </div>
        ),
    },
    "between-the-world-and-me": {
        title: "Between the World and Me",
        author: "Ta-Nehisi Coates",
        topic: "History",
        blank: true,
        body: (
            <div>
                {/*<Blockquote>
                    Race is the child of racism, not the father. And the process
                    of naming "the people" has never been a matter of genealogy
                    and physiognomy so much as one of hierarchy. Difference in
                    hue and hair is old. But the belief in the preeminence of
                    hue and hair, the notion that these factors can correctly
                    organize a society and that they signify deeper attributes,
                    which are indelible -- this is the new idea. at the heart of
                    these new people who have been brought up hopelessly,
                    tragically, deceitfully, to believe that they are white.
                    These new people are, like us, a modern invention.
                </Blockquote>
                <Blockquote>
                    I have raised you to respect every human being as singular.
                </Blockquote>
                <Blockquote>
                    The forgetting is habit, is yet another necessary component
                    of the Dream. They have forgotten the scale of theft that
                    enriched them in slavery; the terror that allowed them, for
                    a century, to pilfer the vote; the segregationist policy
                    that gave them their suburbs. They have forgotten, because
                    to remember would tumble them out of the beautiful Dream and
                    force them to live down here with us, down here in the
                    world. I am convinced that the Dreamers of today, would
                    rather live white than live free. In the Dream they are Buck
                    Rogers, Prince Aragon, an entire race of Skywalkers. To
                    awaken them is to reveal that they are an empire of humans
                    and, like all empires of humans, are built on the
                    destruction of the body. It is to stain their nobility, to
                    make them vulnerable, fallible, breakable humans.
                </Blockquote>*/}
            </div>
        ),
    },
    "dreams-from-my-father": {
        title: "Dreams from My Father",
        author: "Barack Obama",
        topic: "History",
        blank: true,
        body: (
            <div>
                {/* What is a family? Is it just a genetic chain, parents and
        offspring, people like me? Or is it a social construct, an economic
        unit, optimal for child rearing and divisions of labor? Or is it
        something else entirely: a store of shared memories, say? An ambit of
        love? A reach across the void? I could list various possibilities. But
        I'd never arrived at a definite answer, aware early on that, given my
        circumstances, such an effort was bound to fail. Instead, I drew a series
        of circles around myself, with borders that shifted as time passed and
        faces changed but that nevertheless offered the illusion of control. An
        inner circle, where love was constant and claims unquestioned. Then a
        second circle, a realm of negotiated love, commitments freely chosen.
        And then a circle of colleagues, acquaintances; the cheerful gray-haired
        lady who rang up my groceries back in Chicago. Until the circle finally
        widened to embrace a nation or a race, or particular moral course, and
        the commitments were no longer tied to a face or a name but were
        actually commitments I'd made to myself.  */}
            </div>
        ),
    },
    "quiet-please": {
        title: "Quiet, Please",
        author: "Scott Douglas",
        topic: "Social Science",
        blank: true,
    },
    "incredible-journey-of-plants": {
        title: "The Incredible Journey of Plants",
        author: "Stefano Mancuso",
        topic: "Science",
        blank: true,
        body: (
            <div>
                {/* Two great stories: The tomato was brought from central/south America to
        Europe in the 1600s. In the 1800s Italy developed the dishes it's now
        famous for pasta with tomato sauce. That's only been around for a couple
        hundred years. I always thought Leonardo DaVinci Michelangelo where
        eating pizza during the renaissance. But I might have been influenced by
        the Ninja Turtles as a child.There were amazing dates being grown around
        Jerusalem around the time that Jesus walked the Earth. Because of
        changing climate in the region those date trees went extinct. In an
        archaeological dig they found seeds for the trees, and they planted them
        - 2000 year old seeds. And sprouted and grew, but as luck would have it,
        it was a male tree so no dates were produced.  */}
            </div>
        ),
    },
    "i-will-never-see-the-world-again": {
        title: "I Will Never See the World Again",
        author: "Ahmet Altan",
        topic: "History",
        blank: true,
    },
    caffeinated: {
        title: "Caffeinated",
        author: "Murray Carpenter",
        topic: "Science",
        blank: true,
    },
    "test-driven-development": {
        title: "Test-Driven Development",
        author: "Kent Beck",
        topic: "Technical",
        body: (
            <div>
                <p>
                    <b>Summary of TDD:</b>
                </p>
                <Ol>
                    <li>Quickly add a test.</li>
                    <li>Run all the tests and see the new one fail.</li>
                    <li>Make a little change.</li>
                    <li>Run all the tests and see them all succeed.</li>
                    <li>Refactor to remove duplication.</li>
                </Ol>
            </div>
        ),
    },
    // "progressive-web-apps": {
    //     title: "Progressive Web Apps",
    //     author: "Jeremy Keith",
    //     topic: "Technical",
    //     blank: true,
    // },
    "going-offline": {
        title: "Going Offline",
        author: "Jeremy Keith",
        topic: "Technical",
        body: (
            <div>
                <p>
                    This book inspired me to make this website work offline. Try
                    turning off your Wi-Fi and continue browsing.
                </p>
                <p>
                    I also liked what{" "}
                    <a href="http://www.holovaty.com/writing/well-crafted-websites/">
                        Adrian Holovaty
                    </a>{" "}
                    had to say about this.
                </p>
            </div>
        ),
    },
    outliers: {
        title: "Outliers",
        author: "Malcolm Gladwell",
        topic: "Social Science",
        body: (
            <div>
                <Blockquote>
                    "The emerging picture from such studies is that ten thousand
                    hours of practice is required to achieve the level of
                    mastery associated with being a world-class expert -- in
                    anything," writes the neurologist Daniel Levitin. "In study
                    after study, of composers, basketball players, fiction
                    writers, ice skaters, concert pianists, chess players,
                    master criminals, and what have you, this number comes up
                    again and again. Of course, this doesn't address why some
                    people get more out of their practice sessions that others
                    do. But no one has yet found a case in which true
                    world-class expertise was accomplished in less time. It
                    seems that it takes the brain this long to assimilate all
                    that it needs to know to achieve true mastery."
                </Blockquote>
                {/*<p>
                    Note,{" "}
                    <a href="https://www.6seconds.org/2020/01/25/10000-hour-rule/">
                        not everyone agrees
                    </a>{" "}
                    on the 10,000 hour rule.
                </p>*/}
            </div>
        ),
    },
    // "talking-to-strangers": {
    //     title: "Talking to Strangers",
    //     author: "Malcolm Gladwell",
    //     topic: "Social Science",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 The first set of mistakes we make with strangers -- the
    //                 default to truth and the illusion of transparency -- has to
    //                 do with our inability to make sense of the stranger as an
    //                 individual. But on top of those errors we add another, which
    //                 pushes our problem with strangers into crisis. We do not
    //                 understand the importance of the context in which the
    //                 stranger is operating.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "bradbury-chronicles": {
    //     title: "The Bradbury Chronicles",
    //     author: "Sam Weller",
    //     topic: "History",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote></Blockquote>
    //         </div>
    //     ),
    // },
    "why-buddhism-is-true": {
        title: "Why Buddhism Is True",
        topic: "Philosophy",
        author: "Robert Wright",
        body: (
            <div>
                {/*<Blockquote>
                    [Western Buddhists] adopted a version of Buddhism, a
                    version that had been stripped of some supernatural elements
                    typically found in Asian Buddhism, such as a belief in
                    reincarnation and in various deities. This Western Buddhism
                    centers on a part of Buddhist practice that in Asia is more
                    common among monks than among laypeople: meditation, along
                    with immersion in Buddhist philosophy. (Two of the most
                    common Western conceptions of Buddhism -- that it's atheistic
                    and that is revolves around meditation -- are wrong; most
                    Asian Buddhists do believe in gods, though not an omnipotent
                    creator God, and don't meditate.)
                </Blockquote>
                <Blockquote>
                    If you focus on your breathing ... as prescribed in ancient
                    mindfulness texts, the present is where you will be. Still,
                    if you want to go full-on Buddhist ... you need to
                    understand that staying in the present ... isn't the point
                    of the exercise. It is the means to an end, not the end
                    itself.
                </Blockquote>
                <Blockquote>
                    Becoming enlightened, in the Buddhist sense of the term,
                    would entail wholly ridding yourself of the twin illusions
                    from which people tend to suffer: the illusion about what's
                    "in here" -- inside your mind -- and about what's "out there"
                    in the rest of the world. ... Another term used to describe
                    it is <i>liberation</i>, as in liberation from suffering.
                    ... And yet another term for this state is <i>nirvana</i>.
                </Blockquote>
                <Blockquote>
                    If you accept the idea that many of our most troublesome
                    feelings are in one sense or another illusions, then
                    meditation can be seen as, among other things, a process of
                    dispelling illusions.
                </Blockquote>
                <p>
                    <b>Concentration meditation</b>: Focus on your breath or a
                    mantra.
                </p>
                <p>
                    <b>Mindfulness meditation</b>: Start with concentration
                    meditation, then shift your focus to your emotions,
                    sensations, sounds, etc.
                </p>*/}
                <Blockquote>
                    The key to [successful meditation] was to separate the act
                    of observation from the act of evaluation. I still
                    experienced the anxiety, but I no longer experienced it as
                    either good or bad. ... The Buddha believed that the less
                    you judge things -- including the contents of your mind --
                    the more clearly you'll see them, and the less deluded
                    you'll be.
                </Blockquote>
                <Blockquote>
                    The basic idea is to not fight the urge to, say, smoke a
                    cigarette. That doesn't mean you succumb to the urge and
                    light up a cigarette. It just means you don't try to push
                    the urge out of your mind. Rather, you follow the same
                    mindfulness technique that you'd apply to other bothersome
                    feelings -- anxiety, resentment, melancholy, hatred. You
                    just calmly (or as calmly as possible, under the
                    circumstances) examine the feeling. What part of your body
                    is the urge felt in? What is the texture of the urge? Is it
                    sharp? Dull and heavy? The more you do that, the less the
                    urge seems a part of you; you've exploited the basic irony
                    of mindfulness meditation: getting close enough to feelings
                    to take a good look at them winds up giving you a kind of
                    critical distance from them. Their grip on you loosens; if
                    it loosens enough, they're no longer a part of you. There's
                    an acronym used to describe this technique: RAIN. First you
                    Recognize the feeling. Then you Accept the feeling. ... Then
                    you Investigate the feeling. ... Finally, the N stands for
                    Nonidentification, or, equivalently, Nonattachment. Which is
                    a nice note to end on, since not being attached to things
                    was the Buddha's all-purpose prescription for what ails us.
                </Blockquote>
                {/*<p>
                    <b>Four Noble Truths</b>:
                </p>
                <Ol>
                    <li>Life involves suffering.</li>
                    <li>Suffering is caused by craving and attachment.</li>
                    <li>Suffering can be ended.</li>
                    <li>The Eightfold Path is the way to end suffering.</li>
                </Ol>
                <p>
                    <b>Eightfold Path</b>:
                </p>
                <Ol>
                    <li>Healthy understanding</li>
                    <li>Healthy intention</li>
                    <li>Healthy speech</li>
                    <li>Healthy action</li>
                    <li>Healthy livelihood</li>
                    <li>Healthy effort</li>
                    <li>Healthy mindfulness</li>
                    <li>Healthy concentration</li>
                </Ol>*/}
            </div>
        ),
    },
    // buddha: {
    //     title: "Buddha",
    //     author: "Karen Armstrong",
    //     topic: "History",
    //     body: (
    //         <div>
    //             <Blockquote></Blockquote>
    //             <Blockquote>
    //                 As a preliminary to meditation, came the practice [Buddha]
    //                 called "mindfulness" (sati), in which he scrutinized his
    //                 behavior at every moment of the day. He noted the ebb and
    //                 flow of his feelings and sensations, together with the
    //                 fluctuations of his consciousness. ... He observed the way
    //                 his senses and thoughts interacted with the external world,
    //                 and made himself conscious of his every bodily action.
    //             </Blockquote>
    //             <Blockquote>
    //                 It has been found that this habit of attentive self-scrutiny
    //                 has helped Buddhist practitioners to monitor distractions
    //                 that deprive us of peace: as the meditator becomes aware of
    //                 the ephemeral nature of those thoughts and cravings, it
    //                 becomes difficult to identify with them in any way as
    //                 "mine."
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "dont-believe-everything-you-think": {
    //     title: "Don't Believe Everything You Think",
    //     author: "Joseph Nguyen",
    //     topic: "Philosophy",
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 People have a hard time letting go of their suffering. Out
    //                 of a fear of the unknown, they prefer suffering that is
    //                 familiar.
    //                 <br />
    //                 --Thich Nhat Hanh
    //             </Blockquote>
    //             <Blockquote>
    //                 The only time we don't naturally feel at peace are when we
    //                 begin to think about the thoughts we are having, thereby
    //                 blocking our direct connection to the present. Thinking
    //                 takes us away from the present moment and into the past or
    //                 future, which are the only times regret or anxiety exist.
    //             </Blockquote>
    //             <Blockquote>
    //                 The path to peace is not to pursue certainty but to relax
    //                 into uncertainty. To surrender to the ebbs and flows of life
    //                 and accept things as they are instead of how you think they
    //                 should be. It's not about trying to force things to happen a
    //                 certain way but about trusting that you will be okay no
    //                 matter what happens.
    //             </Blockquote>
    //             <p>
    //                 Here is a simple five-step process to help you let go of
    //                 your thinking, which you'll notice conveniently spells out
    //                 the acronym <b>PAUSE</b>.
    //             </p>
    //             <Blockquote>
    //                 P--Pause and take deep breaths to calm your nervous system
    //                 and ground yourself in the present. Become aware that you
    //                 are thinking, but do not judge it.
    //             </Blockquote>
    //             <Blockquote>
    //                 A--Ask yourself, "Is this making me feel the way I want?"
    //             </Blockquote>
    //             <Blockquote>
    //                 U--Understand that you have the choice to stop and let go of
    //                 it.
    //             </Blockquote>
    //             <Blockquote>
    //                 S--Say and repeat the mantra. "Thinking is the root cause of
    //                 suffering."
    //             </Blockquote>
    //             <Blockquote>
    //                 E--Experience your emotions fully without judgment,
    //                 resistance, or thinking (don't think; just feel).
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    quiet: {
        title: "Quiet",
        author: "Susan Cain",
        topic: "Social Science",
        blank: true,
        body: (
            <div>
                <Blockquote></Blockquote>
            </div>
        ),
    },
    "astrophysics-for-people-in-a-hurry": {
        title: "Astrophysics for People in a Hurry",
        author: "Neil deGrasse Tyson",
        topic: "Science",
        body: (
            <div>
                <Blockquote>
                    Want to know what we're made of? Again, the cosmic
                    perspective offers a bigger answer than you might expect.
                    The chemical elements of the universe are forged in the
                    fires of high-mass stars that end their lives in titanic
                    explosions, enriching their host galaxies with the chemical
                    arsenal of life as we know it. The result? The four most
                    common, chemically active elements in our universe --
                    hydrogen, oxygen, carbon, and nitrogen -- are the four most
                    common elements of life on Earth, with carbon serving as the
                    foundation of biochemistry. We do not simply live in this
                    universe. The universe lives within us. {/*p. 203*/}
                </Blockquote>
            </div>
        ),
    },
    "soul-of-an-octopus": {
        title: "The Soul of an Octopus",
        author: "Sy Montgomery",
        topic: "Science",
        body: (
            <div>
                <Blockquote>
                    If free will does exist, research suggests it exists across
                    species. "Even the simple animals are not the predicable
                    automatons that they are often portrayed to be," researcher
                    Bjorn Brembs of Berlin Free University said -- not even
                    fruit flies. ... Their flights were not random. Instead,
                    they matched a mathematical algorithm for a pattern called
                    the Levy distribution. This search pattern is an effective
                    way to find food, a method also known to be used by
                    albatrosses, monkeys, and deer, and the flies made
                    reasonable, not random, choices, too. Scientists have found
                    similar patterns in human behavior, in the flow of emails,
                    letters and money. ... Flies even display individual
                    variation in the choices they make. {/*p. 192)*/}
                </Blockquote>
            </div>
        ),
    },
    "software-design-decoded": {
        title: "Software Design Decoded",
        author: "Marian Petre and Andre van der Hoek",
        topic: "Technical",
        body: (
            <div>
                <Blockquote>
                    Experts live with their heads up and their eyes open. They
                    are aware of their surroundings and "try on" any ideas they
                    spot. They take inspiration from other people, from other
                    areas, and from their wider environment. They continually
                    collect ideas that might be useful. {/*p. 15*/}
                </Blockquote>
                <Blockquote>
                    Experts sketch when they think. They sketch when alone. They
                    sketch in meetings with colleagues or clients. They sketch
                    when they have no apparent need to sketch.
                </Blockquote>
                <Blockquote>
                    Most design projects bog down at some point, when every
                    suggestion seems to lead to further problems. Rather than
                    continuing to "bang their heads" against the same problem,
                    experts switch their focus to another part of the design.
                    {/*p. 41*/}
                </Blockquote>
                <Blockquote>
                    Experts do not take their expertise for granted. They are
                    continuously on the lookout for new knowledge to add to
                    their repertoire and they explicitly seek out and make time
                    for opportunities to learn. {/*p. 65*/}
                </Blockquote>
            </div>
        ),
    },
    bibliotech: {
        title: "BiblioTech",
        author: "John Palfrey",
        topic: "Social Science",
        body: (
            <div>
                <Blockquote>
                    If we do not have libraries, if we lose the notion of free
                    access to most information, the world of the haves and the
                    have-nots will grow further and further apart. Our economy
                    will suffer, and our democracy will be put at unnecessary
                    risk. Everyone has a stake in the future of libraries,
                    archives, and historical societies that safeguard our
                    culture and inspire our people. {/*p. 20*/}
                </Blockquote>
                <Blockquote>
                    By the early part of the twentieth century, the traditional
                    notion of the library as a "treasure chest" or "jewel box"
                    to preserve knowledge for the select few had given way to a
                    far more democratic mission. The library became a central
                    point in a community ... where anyone could pursue knowledge
                    and skills. ... The jewel box model was largely replaced by
                    the lively, open, exciting institution we can visit today.{" "}
                    {/*p. 25*/}
                </Blockquote>
                <Blockquote>
                    The near-future libraries will be a hybrid of yesterday's
                    predominantly print-based world and tomorrow's primarily
                    digital world. {/*p. 28*/}
                </Blockquote>
            </div>
        ),
    },
    "and-there-was-light": {
        title: "And There Was Light",
        author: "Jacques Lusseyran",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    The only way to be completely cured of blindness, and I mean
                    socially, is never to treat it as a difference, a reason for
                    separation, an infirmity, but to consider it a temporary
                    impediment, a peculiarity of course, but one which will be
                    overcome today or at the latest tomorrow. {/*p. 28*/}
                </Blockquote>
                {/*<Blockquote>
                    The human voice forces its way into us. It is really inside
                    ourselves that we hear it. To hear it properly we must allow
                    it to vibrate in our heads and our chests, in our throats as
                    if, for the moment, it really belonged to us. That is surely
                    the reason why voices never deceive us. p. 62
                </Blockquote>*/}
            </div>
        ),
    },
    "meditation-for-fidgety-skeptics": {
        title: "Meditation for Fidgety Skeptics",
        author: "Dan Harris",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    The type of meditation we'll be teaching here is called
                    "mindfulness meditation," which is derived from Buddhism.
                </Blockquote>
                <Blockquote>
                    What mindfulness does is create some space in your head so
                    you can, as the Buddhists say, "respond" rather than simply
                    "react." In the Buddhist view, you can't control what comes
                    up in your head; it all arises out of a mysterious void. We
                    spend a lot of time judging ourselves harshly for feelings
                    that we had no role in summoning. The only thing you can
                    control is how you handle it. (From <i>10% Happier</i>)
                </Blockquote>
                <Blockquote>
                    I consider myself a Buddhist. Not in a religious way, I have
                    no evidence for rebirth or enlightenment. One of my favorite
                    descriptions of Buddhism is that it is not something to
                    believe in, it's something to do. So I personally practice
                    Buddhism by meditating and trying my best to follow the
                    basic ethical principles. (From <i>10% Happier</i>)
                </Blockquote>
                <p>How to meditate:</p>
                <Blockquote>
                    1. Sit comfortably. It's best to have your back straight and
                    spine reasonably straight, which may help prevent an
                    involuntary nap. ... You can close your eyes or you can
                    leave them open and adjust your gaze to a neutral point on
                    the ground.
                </Blockquote>
                <Blockquote>
                    2. Bring your full attention to the feeling of your breath
                    coming in and out. Pick a spot where it's most prominent:
                    your chest, your belly, or your nostrils. You're not
                    thinking about your breath, you're just feeling the raw data
                    of the physical sensations. To help maintain focus, you can
                    make a quiet mental note on the in-breath and out-breath,
                    like <em>in</em> and <em>out</em>.
                </Blockquote>
                <Blockquote>
                    3. The third step is the key. As soon as you try to do this,
                    your mind is almost certainly going to mutiny. You'll start
                    having all sorts of random thoughts. ... No big deal. This
                    is totally normal. The whole game is simply to notice when
                    you are distracted, and begin again.
                </Blockquote>
                {/* <Blockquote>
                    If you find that thinking has swept you away, note{" "}
                    <em>thinking</em>, then return to feeling and noting the
                    breath.
                </Blockquote> */}
            </div>
        ),
    },
    "david-and-goliath": {
        title: "David and Goliath",
        author: "Malcolm Gladwell",
        topic: "Social Science",
        body: (
            <div>
                <Blockquote>
                    Conventional wisdom holds that a disadvantage is something
                    that ought to be avoided -- that it is a setback or a
                    difficulty that leaves you worse off than you would be
                    otherwise. But that is not always the case. {/*p. 102*/}
                </Blockquote>
                <Blockquote>
                    The one trait in a lot of dyslexic people I know is that by
                    the time we got out of college, our ability to deal with
                    failure was very highly developed. And so we look at
                    situations and see much more of the upside than the
                    downside. Because we're so accustomed to the downside. It
                    doesn't faze us. I've thought about it many times, I really
                    have, because it defined who I am. I wouldn't be where I am
                    today without my dyslexia.
                </Blockquote>
                <Blockquote>
                    Courage is not something that you already have that makes
                    you brave when the tough times start. Courage is what you
                    earn when you've been through the tough times and you
                    discover they aren't so tough after all.
                </Blockquote>
            </div>
        ),
    },
    iwoz: {
        title: "iWoz",
        author: "Steve Wozniak",
        topic: "History",
        body: (
            <div>
                <Blockquote>
                    This much I know for sure: I was meant to be an engineer who
                    designs computers, an engineer who writes software, an
                    engineer who tells jokes, and an engineer who teaches other
                    people things. {/*p. 119*/}
                </Blockquote>
                <Blockquote>
                    I now have a roulette shocker -- four people stick in their
                    thumbs and, to the accompaniment of music and flashing
                    lights, it gradually slows down cycling until one person
                    gets a shock. Hardware guys will play this game but software
                    guys are way too chicken. {/*p. 50*/}
                </Blockquote>
                <Blockquote>
                    I never liked alcohol. It made people act noisy and out of
                    control. My dad, for instance, he used to drink martinis. I
                    always noticed how he reasoned differently when he was
                    drunk. Especially as he and I got older, I thought it got
                    really out of hand, the way he would get drunk and yell at
                    my mother. That's not the way he was when he wasn't
                    drinking. So I didn't drink or do drugs. {/*p. 82*/}
                </Blockquote>
                <Blockquote>
                    Most inventors and engineers I've met are like me -- they're
                    shy and they live in their heads. They're almost like
                    artists. In fact, the very best of them are artists.{" "}
                    {/*p. 290*/}
                </Blockquote>
            </div>
        ),
    },
    "obstacle-is-the-way": {
        title: "The Obstacle Is the Way",
        author: "Ryan Holiday",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    Our actions may be impeded ... but there can be no impeding
                    our intentions or dispositions. Because we can accommodate
                    and adapt. The mind adapts and converts to its own purposes
                    the obstacle to our acting. The impediment to action
                    advances action. What stands in the way becomes the way.
                    <br />
                    --Marcus Aurelius
                </Blockquote>
                <Blockquote>
                    Defiance and acceptance come together well in the following
                    principle: There is always a countermove, always an escape
                    or a way through, so there is no reason to get worked up.
                </Blockquote>
                <Blockquote>
                    Remember that this moment is not your life, it's just a
                    moment in your life. Focus on what is in front of you, right
                    now. Ignore what it "represents" or it "means" or "why it
                    happened to you." There is plenty else going on right here
                    to care about any of that.
                </Blockquote>
                <Blockquote>
                    Persist and resist. Persist in your efforts. Resist giving
                    in to distraction, discouragement, or disorder.
                </Blockquote>
                <Blockquote>
                    Pragmatism is not so much realism as flexibility. There are
                    a lot of ways to get from point A to point B. It doesn't
                    have to be a straight line. It's just got to get you where
                    you need to go. But so many of us spend so much time looking
                    for the perfect solution that we pass up what's right in
                    front of us.
                </Blockquote>
                <Blockquote>
                    Some things are bigger than us. This is not necessarily a
                    bad thing. Because we can turn that obstacle upside down
                    too, simply by using it as an opportunity to practice some
                    other virtue or skill -- even if it is just learning to
                    accept that bad things happen, or practicing humility.
                </Blockquote>
                <Blockquote>
                    "This too shall pass" was Lincoln's favorite saying, one he
                    said was applicable in any and every situation one could
                    encounter.
                </Blockquote>
                {/*<Blockquote>
                    Most people start from disadvantage (often with no idea they
                    are doing so) and do just fine. It's not unfair, it's
                    universal. Those who survive it, survive because they took
                    things day by day—that's the real secret. Focus on the
                    moment, not the monsters that may or may not be up ahead.
                </Blockquote>
                <Blockquote>
                    The one thing to guarantee we don't benefit from failure --
                    to ensure it is a bad thing -- is to not learn from it.
                </Blockquote>
                <Blockquote>
                    In the ancient world, virtue was comprised of four key
                    components. Courage. Temperance. Justice. Wisdom. (From{" "}
                    <i>Right Thing, Right Now</i>)
                </Blockquote>
                <Blockquote>
                    Remember that this moment is not your life, it's just a
                    moment in your life. Focus on what is in front of you, right
                    now. Ignore what it "represents" or it "means" or "why it
                    happened to you." There is plenty else going on right here
                    to care about any of that.
                </Blockquote>
                <Blockquote>
                    Take your situation and pretend it is not happening to you.
                    Pretend it is not important, that it doesn't matter. How
                    much easier would it be for you to know what to do? How much
                    more quickly and dispassionately could you size up the
                    scenario and its options?
                </Blockquote>
                <Blockquote>
                    In 1878, Thomas Edison wasn't the only person experimenting
                    with incandescent lights. But he was the only man willing to
                    test six thousand different filaments—including one made
                    from the beard hair of one of his men—inching closer each
                    time to the one that would finally work. And, of course, he
                    eventually found it—proving that genius often really is just
                    persistence in disguise.
                </Blockquote>
                <Blockquote>
                    See things for what they are.
                    <br />
                    Do what we can.
                    <br />
                    Endure and bear what we must.
                </Blockquote>*/}
            </div>
        ),
    },
    "natural-navigator": {
        title: "The Natural Navigator",
        author: "Tristan Gooley",
        topic: "Science",
        body: (
            <div>
                <Blockquote>
                    What a great thought of God was that when He thought a tree!
                    <br />
                    --John Ruskin {/*p. 45*/}
                </Blockquote>
                <Blockquote>
                    The nineteenth-century French physicist Francois Arago
                    wrote, &quot;Whatever may be the progress of the sciences,
                    never will observers who are trustworthy and careful of
                    their reputations venture to foretell the weather.&quot;
                    Weather forecasting is a much derided science to this day
                    because it remains so inexact. This is because while the
                    weather is governed by easily determined factors such as air
                    pressure, humidity, and temperature, the system is so
                    complex that a slight error in reading of the data can
                    quickly become compounded and lead to an inaccurate
                    forecast. {/*p. 198*/}
                </Blockquote>
            </div>
        ),
    },
    "little-book-of-the-icelanders": {
        title: "The Little Book of the Icelanders",
        author: "Alda Sigmundsdottir",
        topic: "Philosophy",
        body: (
            <div>
                <Blockquote>
                    If there is one phrase that captures the Icelanders' innate
                    sense of optimism better than any other, it is this: Þetta
                    reddast. ... Þetta reddast basically means:{" "}
                    <i>This will all work out one way or another</i>. Just lost
                    your job? <i>Þetta reddast.</i> No money in the bank?{" "}
                    <i>Þetta reddast.</i> Economy just melted down?{" "}
                    <i>Þetta reddast.</i> Volcano just spewed ash all over your
                    arable land? <i>Þetta reddast.</i> I love the phrase þetta
                    reddast. To me, it incorporates a profound philosophy.
                    Because when things are totally dark and you really can't
                    see a way out, often the best thing you can do is let go and
                    trust that somehow, some way, things will work out for the
                    best. And the amazing thing is that ... they almost always
                    do.
                </Blockquote>
                <p>
                    Also see:{" "}
                    <Link to={"/notes/þetta-reddast"}>Þetta reddast</Link>.
                </p>
            </div>
        ),
    },
    "designing-data-intensive-applications": {
        title: "Designing Data-Intensive Applications",
        author: "Martin Kleppmann",
        topic: "Technical",
        body: (
            <div>
                <p>
                    <b>Types of databases:</b>
                </p>
                <Ul>
                    <li>Relational databases</li>
                    <li>NoSQL databases</li>
                    <Ul>
                        <li>Document databases</li>
                        <li>Graph databases</li>
                    </Ul>
                </Ul>
                {/*p. 63*/}
                <p>
                    PostgreSQL and MySQL now have support for JSON documents. A
                    hybrid of the relational and document models is a good route
                    for databases to take to the future. {/*p. 42*/}
                </p>
                <Blockquote>
                    Literature on the relational model distinguishes several
                    different normal forms, but the distinctions are of little
                    practical interest. As a rule of thumb, if you're
                    duplicating values that could be stored in just one place,
                    the schema is not normalized. {/*p. 33*/}
                </Blockquote>
                <Blockquote>
                    This is an important trade-off in storage systems:
                    well-chosen indexes speed up read queries, but every index
                    slows down writes. {/*p. 71*/}
                </Blockquote>
                <p>
                    <b>OLTP</b> (online transaction processing) systems are
                    expected to be highly available. These are user-facing
                    storage systems that handle a lot of queries. It's not
                    advisable to allow analysts to run ad-hoc queries on the
                    OLTP systems. The solution is a <b>data warehouse</b> that
                    contains read-only copies of all the OLTP systems.{" "}
                    <b>OLAP</b> (online analytical processing) systems are used
                    by analysts to run complex queries on the data warehouse.
                    {/*p. 92, 103*/}
                </p>
                <p>
                    <b>Star schema</b>: a common way to organize data
                    warehouses. The middle table surrounded by its dimension
                    tables is like the rays of a star. Star schemas are often
                    preferred (over snowflake) because they are simpler for
                    analysts to work with. {/*p. 95*/}
                </p>
                <p>
                    <b>Snowflake schema</b>: a variation of the star schema
                    where the dimension tables are normalized. {/*p. 95*/}
                </p>
                <p>
                    The simplest thing to do when you have a higher load is to
                    scale up (buy a more powerful machine). By contrast, scaling
                    out (adding more machines) is more complex. The most common
                    approach for databases is <b>leader-based replication</b>.
                    The leader receives all the writes and replicates them to
                    the followers. A client can read from any of the replicas or
                    the leader. <b>Multi-leader replication</b> is more complex
                    and is often considered dangerous territory that should be
                    avoided if possible. The third approach is{" "}
                    <b>leaderless replication</b>. This allows any replica to
                    directly accept writes from clients. Amazon did this with
                    DynamoDB, and other databases have followed suit. This kind
                    of database is also known as <b>Dynamo-style</b>.
                </p>
                <p>
                    The safety guarantees provided by transactions are defined
                    by the acronym <b>ACID</b>:
                </p>
                <Ul>
                    <li>
                        <b>Atomicity</b>: Either all of the transaction is
                        applied or none of it is.
                    </li>
                    <li>
                        <b>Consistency</b>: The transaction cannot bring the
                        database into an inconsistent state. This depends more
                        on the application than the database.
                    </li>
                    <li>
                        <b>Isolation</b>: Concurrent transactions are isolated
                        from each other.
                    </li>
                    <li>
                        <b>Durability</b>: Once a transaction has been
                        committed, it will remain so.
                    </li>
                </Ul>
                <p>
                    <b>Unix philosophy</b>: Make each program do one thing well.
                    To do a new job, build afresh rather than complicate old
                    programs by adding new "features".
                </p>
                <p>Two types of message brokers:</p>
                <Ul>
                    <li>
                        <b>AMQP/JMS-style message broker</b>: The broker assigns
                        messages to consumers, and consumers acknowledge
                        messages when they have been processed. Messages are
                        deleted from the broker once they have been
                        acknowledged. The exact order of messages is not
                        important. There is no need to go back and read old
                        messages again.
                    </li>
                    <li>
                        <b>Log-based message message broker</b>: The broker
                        assigns all messages in a partition to the same consumer
                        node, and always delivers messages in the same order.
                        Parallelism is achieved by having multiple partitions.
                        The broker retains messages for a configurable period of
                        time, and consumers can go back and read old messages.
                    </li>
                </Ul>
            </div>
        ),
    },
    "ai-assisted-programming": {
        title: "AI-Assisted Programming",
        author: "Tom Taulli",
        topic: "Technical",
        body: (
            <div>
                <Blockquote>
                    AI-assisted programming tools like Copilot ... don't really
                    "get" programming languages like compilers do. ... Instead,
                    they use AI to guess and suggest bits of code based on tons
                    of code that's already out there. Since the tools are
                    playing the odds, the suggestions can vary a lot. ...
                    Sometimes, AI tools miss something simple like a bracket,
                    which a human coder or compiler would spot in a heartbeat.
                    That is because the LLMs are based on predicting patterns,
                    not a compiler engine. If something's not common in the
                    training, they might not catch it.
                </Blockquote>
                <Blockquote>
                    Prompt-engineering is a subfield of maching learning and
                    natural language processing, which is the study of enabling
                    computers to understand and interpret human language. The
                    main goal is to figure out how to talk to large language
                    models.
                </Blockquote>
                <p>
                    A prompt for an LLM has four main components (you don't need
                    all four components for every prompt):
                </p>

                <Ul>
                    <li>
                        <b>Context</b>
                    </li>
                    <Ul>
                        <li>
                            Example: You are an experienced software engineer
                            specializing in debugging Python applications.
                        </li>
                    </Ul>
                    <li>
                        <b>Instructions for the LLM</b>
                    </li>
                    <Ul>
                        <li>
                            Summarization -- Example: Summarize the main points
                            of the following documentation.
                        </li>
                        <li>
                            Text classification -- Example: Could you summarize
                            the overall sentiment of the following feedback?
                        </li>
                        <li>
                            Recommendation -- Example: Could you recommend any
                            optimizations for the following code to make it
                            faster and more readable?
                        </li>
                        <li>
                            Translation -- Example: Translate the following UI
                            text into French. Save, Exit, File, Edit, Help.
                        </li>
                    </Ul>
                    <li>
                        <b>Input of content</b>
                    </li>
                    <Ul>
                        <li>
                            When crafting prompts, it's helpful to use special
                            symbols like ### and """
                        </li>
                        <li>
                            Example: Extract the key implementation steps for
                            the API from the text below:
                            <br />
                            Documentation: """
                            <br />
                            [API documentation text here]
                            <br />
                            """"
                        </li>
                    </Ul>
                    <li>
                        <b>Format</b>
                    </li>
                    <Ul>
                        <li>
                            Example: Create a Python function that takes a list
                            of user objects (each object containing a user's ID
                            and name) and returns a JSON object that maps user
                            IDs to names. Format the output as JSON.
                        </li>
                    </Ul>
                </Ul>
            </div>
        ),
    },
    "powerful-python": {
        title: "Powerful Python",
        author: "Aaron Maxwell",
        topic: "Technical",
        body: (
            <div>
                <p>
                    <code>iter()</code>
                </p>
                <pre>
                    {`
numbers = [1, 2, 3]
iterator_object = iter(numbers)
print(next(iterator_object))  # 1
print(next(iterator_object))  # 2
print(next(iterator_object))  # 3
print(next(iterator_object))  # StopIteration

# You can also use a for loop
for n in numbers:
    print(n)

print(sum(numbers))  # 6
                    `}
                </pre>
                <p>
                    You don't normally call <code>iter()</code> directly.
                    Instead, you use a for loop, and Python calls it for you.
                </p>
                <p>
                    <b>Generators</b> are a useful shortcut for creating
                    iterators. Generators have a smaller memory footprint than
                    lists because they don't store all the values at once.
                </p>
                <pre>
                    {`
def generator_function():
    n = 1
    while n < 4:
        yield n
        n += 1

generator_object = generator_function()
print(next(generator_object))  # 1
print(next(generator_object))  # 2
print(next(generator_object))  # 3
print(next(generator_object))  # StopIteration

# You can also use a for loop
for n in generator_function():
    print(n)

print(sum(generator_function()))  # 6
                    `}
                </pre>
                <p>
                    <code>range</code>, <code>dict.keys</code>,{" "}
                    <code>dict.values</code>, <code>map</code>,{" "}
                    <code>filter</code>, <code>zip</code>, and{" "}
                    <code>enumerate</code> return objects that are like
                    generators in that they produce values on demand instead of
                    storing them all in memory at once.
                </p>
                <p>
                    You can think of class methods as alternative constructors.
                </p>
                <pre>
                    {`
class Money:
    def __init__(self, dollars, cents):
        self.dollars = dollars
        self.cents = cents

    @classmethod
    def from_pennies(cls, total_cents):
        dollars = total_cents // 100
        cents = total_cents % 100
        return cls(dollars, cents)

piggie_bank_cash = Money.from_pennies(3217)
print(type(piggie_bank_cash))  # <class '__main__.Money'>
print(piggie_bank_cash.dollars)  # 32
print(piggie_bank_cash.cents)  # 17
                    `}
                </pre>
            </div>
        ),
    },
    // "right-thing-right-now": {
    //     title: "Right Thing, Right Now",
    //     author: "Ryan Holiday",
    //     topic: "Philosophy",
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 The Stoics said we should try to see every person we meet as
    //                 an opportunity for kindness. This is a wonderful change in
    //                 perspective. It transforms daily life, as challenging and
    //                 noxious as it can be, into a series of chances, one after
    //                 another, to be nice, to do something nice, to be
    //                 considerate, to make a positive difference.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "courage-is-calling": {
    //     title: "Courage Is Calling",
    //     author: "Ryan Holiday",
    //     blank: true,
    // },
    // "right-thing-right-now": {
    //     title: "Right Thing, Right Now",
    //     author: "Ryan Holiday",
    //     blank: true,
    // },
    // 'quiet-strength': {
    //   title: 'Quiet Strength',
    //   author: 'Rosa Parks',
    //   body: (
    //     <Blockquote>
    //       I saw and heard so much as a child growing up with hate and injustice
    //       against black people. I learned to put my trust in God and to seek Him
    //       as my strength. Long ago I set my mind to be a free person and not give
    //       in to fear.
    //     </Blockquote>
    //   ),
    // },
    // 'rosa-parks': {
    //   title: 'Rosa Parks',
    //   author: 'Douglas Brinkley',
    //   blank: true,
    //   body: (
    //     <div>
    //       <Blockquote>
    //         Intuitively, Parks had engaged in an act of passive resistance, a
    //         precept named by Leo Tolstoy and embraced by Mahatma Gandhi but drawn
    //         from the New Testament Parks knew so well. She had learned from
    //         Matthew 5:39 of Jesus' teaching that if an adversary slaps you on one
    //         cheek, you should trun the other. Although she took the lesson to
    //         heart and understood that it meant the victim should turn the
    //         aggressor on a higher road, Parks was not about to tolerate being
    //         slapped on her cheek or anywhere else by James Blake or anyone else.
    //         As Parks read the New Testament, Jesus had been speaking
    //         metaphorically, for when he was slapped on an occasion described in
    //         John 18:23, he renounced the offender. Thus Parks not only refused to
    //         get back on Blake's bus; she avoided him for the next twelve years,
    //         opting to walk home in the rain rather than suffer further injustice
    //         at the hands of a bully.
    //       </Blockquote>
    //       <Blockquote>
    //         Parks recounts her brief stint in jail in My Story, a straightforward
    //         narrative that makes a valuable companion piece to Thoreau's essay on
    //         "Civil Disobedience" and King's "Letter from a Birmingham City Jail."
    //       </Blockquote>
    //     </div>
    //   ),
    // },
    // 'come-what-may': {
    //   title: 'Come What May, and Love It',
    //   author: 'Joseph B. Wirthlin',
    //   body: (
    //     <div>
    //       <Blockquote>
    //         Whenever my steps led through seasons of sadness and sorrow, my
    //         mother's words often came back to me:{' '}
    //         <a href="https://www.lds.org/general-conference/2008/10/come-what-may-and-love-it?lang=eng">
    //           Come what may, and love it
    //         </a>
    //         .
    //       </Blockquote>
    //       <p>Learn to Laugh</p>
    //       <Blockquote>
    //         The next time you're tempted to groan, you might try to laugh instead.
    //         It will extend your life and make the lives of all those around you
    //         more enjoyable.
    //       </Blockquote>
    //       <p>Seek for the Eternal</p>
    //       <Blockquote>
    //         My son, peace be unto thy soul; thine adversity and thine afflictions
    //         shall be but a small moment. (
    //         <a href="https://www.lds.org/scriptures/dc-testament/dc/121.7-8?lang=eng#6">
    //           D&C 127:7
    //         </a>
    //         )
    //       </Blockquote>
    //       <p>The Principle of Compensation</p>
    //       <Blockquote>
    //         That which is taken away from those who love the Lord will be added
    //         unto them in His own way. While it may not come at the time we desire,
    //         the faithful will know that every tear today will eventually be
    //         returned a hundredfold with tears of rejoicing and gratitude.
    //       </Blockquote>
    //       <p>Trust in the Father and the Son</p>
    //       <Blockquote>
    //         The simple secret is this: put your trust in the Lord, do your best,
    //         then leave the rest to Him.
    //       </Blockquote>
    //     </div>
    //   ),
    // },
    // "12-rules-for-life": {
    //     title: "12 Rules for Life",
    //     author: "Jordan B. Peterson",
    //     blank: true,
    //     body: (
    //         <div>
    //             <p>RULE 1: Stand up straight with your shoulders back</p>
    //             <p>
    //                 RULE 2: Treat yourself like someone you are responsible for
    //             </p>
    //             <Blockquote>
    //                 Most individuals are dealing with one or more serious health
    //                 problems while going productively and uncomplainingly about
    //                 their business. If anyone is fortunate enough to be in a
    //                 rare period of grace and health, personally, then he or she
    //                 typically has at least one close family member in crisis.
    //                 Yet people prevail and continue to do difficult and
    //                 effortful tasks to hold themselves and their families and
    //                 society together. To me this is miraculous. (p. 61)
    //             </Blockquote>
    //             <p>
    //                 RULE 3: Make friends with people who want the best for you
    //             </p>
    //             <p>
    //                 RULE 4: Compare yourself to who you were yesterday, not to
    //                 who someone else is today
    //             </p>
    //             <p>
    //                 RULE 5: Do not let your children do anything that makes you
    //                 dislike them
    //             </p>
    //             <Blockquote>
    //                 We assume that rules will irremediably inhibit what would
    //                 otherwise be the boundless and intrinsic creativity of our
    //                 children, even though the scientific literature clearly
    //                 indicates, first, that creativity beyond the trivial is
    //                 shockingly rare and, second, that strict limitations
    //                 facilitate rather than inhibit creative achievement. p. 124
    //             </Blockquote>
    //             <p>
    //                 RULE 6: Set your house in perfect order before you criticize
    //                 the world
    //             </p>
    //             <Blockquote>
    //                 You can know that something is wrong or right without
    //                 knowing why. ... Every person is too complex to know
    //                 themselves completely, and we all contain wisdom that we
    //                 cannot comprehend.
    //             </Blockquote>
    //             <p>RULE 7: Pursue what is meaningful (not what is expedient)</p>
    //             <p>RULE 8: Tell the truth -- or, at least, don't lie</p>
    //             <p>
    //                 RULE 9: Assume that the person you are listening to might
    //                 know something you don't
    //             </p>
    //             <p>RULE 10: Be precise in your speech</p>
    //             <p>
    //                 RULE 11: Do not bother children when they are skateboarding
    //             </p>
    //             <p>RULE 12: Pet a cat when you encounter one on the street</p>
    //             <Blockquote>
    //                 Dogs are great. Cats, however, are their own creatures. They
    //                 aren't social or hierarchical (except in passing). They are
    //                 only semi-domesticated. ... Dogs have been tamed, but cats
    //                 have made a decision. They appear willing to interact with
    //                 people, for some strange reasons of their own. To me, cats
    //                 are a manifestation of nature, of Being, in an almost pure
    //                 form. Furthermore, they are a form of Being that looks at
    //                 human beings and approves. ... Maybe when you are going for
    //                 a walk and your head is spinning a cat will show up and if
    //                 you pay attention to it then you will get a reminder for
    //                 just fifteen seconds that the wonder of Being might make up
    //                 for the ineradicable suffering that accompanies it.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "little-book-of-stoicism": {
    //     title: "The Little Book of Stoicism",
    //     author: "Jonas Salzgeber",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 "So, what should each of us say to every trial we face? This
    //                 is what I've trained for, this is my discipline!" Hey, a
    //                 boxer who gets punched in the face won't leave the ring,
    //                 it's what he prepared for, it's his discipline.
    //             </Blockquote>
    //             <Blockquote>
    //                 Don't explain your philosophy. Embody it. -- Epictetus
    //             </Blockquote>
    //             <Blockquote>
    //                 The central teaching of Epictetus was that there are things
    //                 which are up to us and things which aren't; we should always
    //                 "make the best use of what is in our power, and take the
    //                 rest as it happens." This idea is the cornerstone of Stoic
    //                 philosophy.
    //             </Blockquote>
    //             <Blockquote>
    //                 Stoicism requires us to be able to not react impulsively to
    //                 what happens to us. It requires us to spot our initial
    //                 impressions, so that we recognize our ability to choose our
    //                 response. Once we're able to spot our automatic impressions,
    //                 we can test them and actively choose to go with the
    //                 impression or not.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "how-to": {
    //     title: "How To",
    //     author: "Randall Munroe",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 Could you open bottles using a nuclear bomb? This is a
    //                 completely ridiculous suggestion, so it should come as no
    //                 surprise that it was studied by the US government during the
    //                 Cold War. Early in 1955, the Federal Civil Defense
    //                 Administration bought beer, soda, and carbonated water from
    //                 local stores, then tested nuclear weapons on them. Now, they
    //                 weren't trying to open the beverages. The purpose of the
    //                 test was to see how well the containers survived, and
    //                 whether the contents were contaminated. The civil defense
    //                 planners figured that, after a nuclear explosion in a US
    //                 city, potable water would likely be needed by first
    //                 responders, and they wanted to know whether commercial
    //                 beverages would be safe source of hydration. ... Bottles and
    //                 cans were placed in various locations around the Nevada test
    //                 site for each explosion. ... The beverages fared
    //                 surprisingly well. Most of them survived the blast intact.
    //                 ... They also had low levels of radioactive contamination,
    //                 and even tasted ok.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "utah-wildflowers": {
    //     title: "Utah Wildflowers",
    //     author: "Richard J. Shaw",
    //     blank: true,
    // },
    // "algebra-of-happiness": {
    //     title: "The Algebra of Happiness",
    //     author: "Scott Galloway",
    //     blank: true,
    // },
    // "this-is-water": {
    //     title: "This Is Water",
    //     author: "David Foster Wallace",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 Everybody worships. The only choice we get is what to
    //                 worship. And an outstanding reason for choosing some sort of
    //                 god or spiritual-type thing to worship -- be it J.C. or
    //                 Allah, be it Yahweh or the Wiccan mother-goddess or the Four
    //                 Noble Truths or some infrangible set of ethical principles
    //                 -- is that pretty much anything else you worship will eat
    //                 you alive. If you worship money and things -- if they are
    //                 where you tap real meaning in life -- then you will never
    //                 have enough. ... Worship your intellect, being seen as smart
    //                 -- you will end up feeling stupid, a fraud. ... The
    //                 insidious thing about these forms of worship is not that
    //                 they're evil or sinful; it is that they are unconscious.
    //                 They are default settings.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    // "power-of-different": {
    //     title: "The Power of Different",
    //     author: "Gail Saltz",
    //     blank: true,
    // },
    // storyteller: {
    //     title: "The Storyteller",
    //     author: "Dave Grohl",
    //     blank: true,
    //     body: (
    //         <div>
    //             <Blockquote>
    //                 My inability to read music sharpened my musical memory,
    //                 because the only way I could retain information was to take
    //                 a mental snapshot of it in my head, which honed my ability
    //                 to focus. It was the handicap of not having lessons or even
    //                 an actual drum set to learn on that challenged me and made
    //                 me work even harder to get better, to find a way to succeed.
    //             </Blockquote>
    //         </div>
    //     ),
    // },
    //"stoic-challenge": {
    //    title: "The Stoic Challenge",
    //    author: "William B. Irvine",
    //    body: (
    //        <div>
    //            <Blockquote>
    //                Consider the case of Stoic philosopher Paconius Agrippinus,
    //                who in around 67 CE was openly critical of the Emperor Nero.
    //                A messenger ... appeared with the news that he had been
    //                found guilty of treasonous behavior and condemned. "To
    //                banishment or death?" he asked. "To banishment," the
    //                messenger replied. Agrippinus responded with a question:
    //                "Was my estate in Aricia taken?" "No," said the messenger.
    //                "In that case," said Agrippinus, "I will go to Aricia and
    //                dine." In behaving in this manner, Agrippinus was simply
    //                applying advice that, although perfectly sensible, is easy
    //                to forget. When the number of options available is limited,
    //                it is foolish to fuss and fret. We should instead simply
    //                choose the best of them and get on with life.
    //            </Blockquote>
    //            <Blockquote>
    //                Instead of comparing [their current situation] to the
    //                superior situations they routinely found themselves dreaming
    //                of, they compared it to the inferior situations they
    //                imagined and thereupon concluded that things weren't so bad.
    //                This process, now known as <i>negative visualization</i>, is
    //                one of the most remarkable psychological instruments in the
    //                Stoic toolkit. It is important to realize that in advising
    //                us to negatively visualize, the Stoics weren't advocating
    //                that we dwell on how things could be worse; that would
    //                indeed be a recipe for misery. Instead, what we should do is
    //                periodically have <i>flickering thoughts</i> about how our
    //                lives and circumstances could be worse.
    //            </Blockquote>
    //            {/*<Blockquote>
    //                Almost regardless of how bad things are, they could be
    //                worse, and this alone is reason to give thanks.
    //            </Blockquote>*/}
    //            <Blockquote>
    //                If we presented a Stoic with the list of Kubler-Ross's five
    //                stages of grief, his response would be to skip the first
    //                four -- denial, anger, bargaining, and depression -- and go
    //                directly to stage five, acceptance.
    //            </Blockquote>
    //        </div>
    //    ),
    //},
    //"standing-for-something": {
    //    title: "Standing for Something",
    //    author: "Gordon B. Hinckley",
    //    topic: "Philosophy",
    //    blank: true,
    //},
    //"how-to-be-an-antiracist": {
    //    title: "How to Be an Antiracist",
    //    topic: "Philosophy",
    //    blank: true,
    //    body: (
    //        <div>
    //            {/*<Blockquote>
    //                ANTIRACIST: One who is expressing the idea that racial
    //                groups are equals and none needs developing, and is
    //                supporting policy that reduces racial inequity.
    //            </Blockquote>*/}
    //        </div>
    //    ),
    //},
    //"we-dont-need-raods": {
    //    title: "We Don't Need Roads",
    //    author: "Caseen Gaines",
    //    topic: "History",
    //    blank: true,
    //},
    //"bomber-mafia": {
    //    title: "The Bomber Mafia",
    //    author: "Malcolm Gladwell",
    //    topic: "History",
    //    blank: true,
    //    body: (
    //        <div>
    //            <Blockquote></Blockquote>
    //        </div>
    //    ),
    //},
    //"soul-boom": {
    //    title: "Soul Boom",
    //    author: "Rainn Wilson",
    //    topic: "Philosophy",
    //    body: (
    //        <div>
    //            <Blockquote>
    //                The first evidence of humanity having some kind of spiritual
    //                journey is seen in some of the earliest human settlements,
    //                more specifically the burial mounds of thirty thousand to
    //                one hundred thousand years ago. In almost every single
    //                ancient culture around the world (including in pre-Homo
    //                sapiens species like Peking Man and Neanderthals), bodies
    //                were buried in shallow graves, and alongside those bodies
    //                were regularly placed items and objects that the deceased
    //                individual might need in the afterlife: swords, jewelry,
    //                pets, canoes, tools.
    //            </Blockquote>
    //            <Blockquote>
    //                The fastest-growing religion is one you may not have heard
    //                of. Its followers are called the Nones. So-called because on
    //                surveys, when asked about religious affiliation, they check
    //                "none" or "none of the above." Nones are agnostics and
    //                atheists, yes, but by far the majority are self-titled
    //                "spiritual but not religious." This is a category ascribed
    //                to by well over a third of millennials and far more Gen
    //                Zers.
    //            </Blockquote>
    //            <Blockquote>
    //                There is a set of behavioral consistencies that emerge from
    //                a group of people focused on the same collective mindset. A
    //                common purpose, mission, and sense of meaning that creates
    //                inner peace and social stability. Evolutionary biologists
    //                have even suggested that religion was naturally selected
    //                because it was so successful in building communities in
    //                which everyone cared for each other, thus increasing the
    //                survival rate of adherents.
    //            </Blockquote>
    //        </div>
    //    ),
    //},
};
